export default "__VITE_ASSET__Et30YBHW__"